export default function Intro() {
  return (
    <section className="py-20 bg-white border-b border-gray-100">
      <div className="max-w-4xl mx-auto text-center px-6">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-snug mb-4">
          Built for Performance. Designed for Beauty.
        </h2>
        <p className="text-gray-600 text-base leading-relaxed max-w-2xl mx-auto">
          Our high-performance stretch tents offer unmatched versatility and style. 
          Waterproof, UV resistant, fire rated, and engineered to your exact specifications,
          perfect for weddings, corporate events, and festivals.
        </p>
      </div>
    </section>
  );
}
